import LeadsApi from 'site-react/api/LeadsApi';
import logError from 'site-react/core/helpers/logError';

/**
 * Make the payload compatible with the spacious endpoint,
 * and send the payload via the leads api.
 *
 * @param payload - the payload for the lead
 * @returns - Response from the api
 */

const processLead = async (payload) => {
  const api = new LeadsApi();
  const hubspotPayload = payload;
  try {
    await api.createLead(hubspotPayload);
  } catch (error) {
    logError(error);
    throw error;
  }
};
export default processLead;
